export default __webpack_public_path__ + "static/media/before-after-1.76222c33.png";